export const currencyFormat = (amount: string) => {
    const num = parseFloat(amount).toFixed(2);
    const currencyAmount = num.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return currencyAmount;
}